import React from 'react';
import styles from './DateAndTitleListItem.module.scss';

const DateAndTitleListItem = ({
  date,
  subtitle,
  title,
  link,
  targetBlank = false
}) => {
  return (
    <div className={styles.DateAndTitleListItemWrapper}>
      <div className={styles.DateAndTitleListItemDate}>
        <div className={styles.DateAndTitleListItemMonth}>{date.month}</div>
        <div className={styles.DateAndTitleListItemDay}>{date.day}</div>
        <div className={styles.DateAndTitleListItemYear}>{date.year}</div>
      </div>
      <div className={styles.DateAndTitleListItemTextWrapper}>
        {subtitle && (
          <div className={styles.DateAndTitleListItemSubtitle}>{subtitle}</div>
        )}
        <a
          href={link}
          target={targetBlank ? '_blank' : '_self'}
          rel="noopener noreferrer"
          className={styles.DateAndTitleListItemTitle}
        >
          {title}
        </a>
      </div>
    </div>
  );
};

export default DateAndTitleListItem;



// WEBPACK FOOTER //
// ./src/common/components/DateAndTitleListItem/DateAndTitleListItem.js